import { useContext } from 'react';
import { TenantContext, type TenantContextValue } from '@/providers/tenantContext';

export type { TenantContextValue, AppRole, TenantMe } from '@/providers/tenantContext';

export function useTenant(): TenantContextValue {
  const context = useContext(TenantContext);
  if (context === undefined) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
}
